var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("multiselect", {
        attrs: {
          "open-direction": "bottom",
          options: _vm.placeCriteria,
          label: "label",
          "track-by": "value",
          "show-labels": false,
          placeholder: _vm.translations.specialcriteria,
          searchable: false
        },
        model: {
          value: _vm.selectedCriteria,
          callback: function($$v) {
            _vm.selectedCriteria = $$v
          },
          expression: "selectedCriteria"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }